var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.62109 0.665039C3.04611 0.369151 3.40053 0.534246 3.49023 0.658203C3.66891 0.905944 5.43653 3.58462 5.62891 3.88867C5.69525 3.99358 5.73618 4.25869 5.53027 4.64844L5.5293 4.65039C5.39681 4.90303 4.94547 5.6969 4.72852 6.07617L4.57129 6.35156L4.75391 6.61133C5.00355 6.96661 5.63425 7.79748 6.91699 9.08008C8.20041 10.3619 9.02977 10.9948 9.3877 11.2451L9.64746 11.4268L9.92285 11.2695C10.3023 11.0525 11.0961 10.6011 11.3486 10.4688L11.3506 10.4678C11.7315 10.2657 11.9986 10.3022 12.1094 10.3701C12.4245 10.5634 15.0768 12.3247 15.3398 12.5068V12.5078C15.3913 12.5441 15.4459 12.6129 15.4766 12.7168L15.498 12.833C15.5114 12.9948 15.4616 13.1904 15.3311 13.3779L15.3291 13.3799C15.3249 13.3854 14.9198 13.9447 14.4043 14.5C14.144 14.7804 13.8684 15.0458 13.6123 15.2373C13.3343 15.4452 13.1655 15.4997 13.1025 15.5H13.1016C11.8753 15.4599 10.4863 14.838 9.09473 13.9062C7.7146 12.9822 6.38882 11.7927 5.29785 10.7012L5.29688 10.7002C4.20456 9.60867 3.01468 8.28227 2.09082 6.90332C1.15913 5.51265 0.538205 4.12721 0.5 2.9082V2.90723C0.498237 2.84878 0.545924 2.68294 0.751953 2.40234C0.941191 2.14466 1.20633 1.8667 1.48828 1.60352C1.76777 1.34264 2.05078 1.10766 2.2666 0.936523C2.46387 0.780106 2.60041 0.680118 2.62109 0.665039Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFilled);
export default ForwardRef;